import styled from 'styled-components';

export const Heading = styled.div`
    background-color: var(--color-gray-200);
`;

export const Title = styled.div`
    font-size: 1.1em;
    font-weight: 600;
    text-transform: uppercase;
`;

export const Body = styled.div`
    /* outline: 1px solid green; */
`;

export const Card = styled.div`
    /* ${props => console.log(props)} */
    border: 1px solid var(--color-gray-100);
    border-radius: 0;
`;
